import { render } from "./HealthCheckContainer.vue?vue&type=template&id=79a90f5d&ts=true"
import script from "./HealthCheckContainer.vue?vue&type=script&lang=ts"
export * from "./HealthCheckContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_release/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__